import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import { Spinner } from "@/components/ui/spinner"

export function AdminSettingsLoadState({
  loading = false,
  message,
  retrying = false,
  onRetry,
}: {
  loading?: boolean
  message?: string
  retrying?: boolean
  onRetry: () => void
}) {
  const { t } = useTranslation()

  if (loading) return <Spinner />

  return (
    <div className="space-y-3 rounded-md border p-4" role="alert">
      <p className="text-sm">
        {message ??
          t(
            "adminDashboard.settingsLoadError",
            "These settings could not be loaded. Retry before making changes."
          )}
      </p>
      <Button disabled={retrying} size="sm" variant="outline" onClick={onRetry}>
        {t("common.retry", "Retry")}
      </Button>
    </div>
  )
}
